export default __webpack_public_path__ + "static/media/feature-compliance-1.9c030710.png";